import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth.guard';
import { BrowserSupportGuard } from './core/browser-support.guard';
import { CapabilityGuard } from './core/capability.guard';
import { ReadinessGuard } from './core/readiness.guard';
import { RedirectComponent } from './redirect/redirect.component';
import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard],
  },
  {
    path: 'profile-select',
    loadChildren: () => import('./profile-select/profile-select.module').then(m => m.ProfileSelectModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'dashboard:view' },
  },
  {
    // Not linked in the nav by design — reachable by direct URL (e.g. an admin
    // opening /settings to configure the global click sound, language, theme).
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard],
  },
  {
    path: 'exercises/:id/play',
    loadChildren: () => import('./gameplay/gameplay.module').then(m => m.GameplayModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'exercises:view' },
  },
  {
    path: 'exercises',
    loadChildren: () => import('./exercises/exercises.module').then(m => m.ExercisesPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'exercises:view' },
  },
  {
    path: 'scores/:id/play',
    loadChildren: () => import('./gameplay/pages/score-gameplay/score-gameplay.module').then(m => m.ScoreGameplayModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'scores:view' },
  },
  {
    path: 'scores',
    loadChildren: () => import('./scores/scores.module').then(m => m.ScoresPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'scores:view' },
  },
  {
    path: 'progress',
    loadChildren: () => import('./progress/progress.module').then(m => m.ProgressPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'progress:view' },
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'users:view' },
  },
  {
    path: 'courses',
    loadChildren: () => import('./courses/courses.module').then(m => m.CoursesPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'courses:view' },
  },
  {
    path: 'categories',
    loadChildren: () => import('./categories/categories.module').then(m => m.CategoriesPageModule),
    canActivate: [BrowserSupportGuard, ReadinessGuard, AuthGuard, CapabilityGuard],
    data: { requiredCapability: 'categories:view' },
  },
  {
    path: 'service-unavailable',
    component: ServiceUnavailableComponent,
  },
  {
    path: 'unsupported-browser',
    component: UnsupportedBrowserComponent,
  },
  {
    path: '',
    component: RedirectComponent,
    pathMatch: 'full',
  },
  {
    path: '**',
    component: RedirectComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
